import { RocheUIAccordion, RocheUITabs } from '@repo/roche-ui';
import React from 'react';
import { blokToComponent } from '../../helpers/blok-to-component';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { trackAccordionToggle, trackTabClick } from '../../helpers/roche-accordion-tabs-tracking';
import { RocheAccordionTabs as RocheAccordionTabsTypes } from '../../types/global';

type RocheAccordionTabsProps = BlokToComponentProps<
  RocheAccordionTabsTypes & {
    slotted: {
      _uid: string;
      component: string;
      headline: string;
      icon: string;
      slotted: any;
    }[];
    start_position?: string;
  }
>;

export const RocheAccordionTabs = ({ blok, getComponent }: RocheAccordionTabsProps) => {
  const isAccordion = blok.type === 'accordion';

  // map the _uid from storyblok to id for the accordion or tabs items,
  // since we do not want to use the _uid directly in the components
  const items = blok.slotted?.map((item) => ({
    ...item,
    // eslint-disable-next-line no-underscore-dangle
    id: item._uid,
  }));

  const renderAccordion = () => (
    <RocheUIAccordion sections={items} initiallyOpen={Number(blok.start_position)} onPanelToggle={trackAccordionToggle}>
      {blok.slotted?.map((item) => blokToComponent({ getComponent, blok: item }, 'roche-accordion-item'))}
    </RocheUIAccordion>
  );

  // We do not want an apperance called 'pipeline' in the tabs component,
  // so we map it to 'filter-gray' which is the equivalent to what was used to be called 'pipeline'.
  const appearance = blok.appearance === 'pipeline' ? 'filter-gray' : blok.appearance;
  const renderTabs = () => (
    <RocheUITabs
      tabs={items}
      initiallySelected={Number(blok.start_position)}
      appearance={appearance}
      onTabClick={trackTabClick}
    >
      {blok.slotted?.map((item) => blokToComponent({ getComponent, blok: item }, 'roche-tab-item'))}
    </RocheUITabs>
  );

  return isAccordion ? renderAccordion() : renderTabs();
};
